<template>
    <Card :dis-hover="true">
        <Tabs v-model="saleType"
            :animated="false"
            :capture-focus="true">
            <TabPane label="现售发货单"
                name="curSale">
                <CurSaleDeliveryList v-if="saleType ==='curSale'"
                    userType='E'
                    ref="curSaleDeliveryList" />
            </TabPane>
            <TabPane label="预售发货单"
                name="preSale">
                <PreSaleDeliveryList v-if="saleType==='preSale'"
                    userType='E'
                    ref="preSaleDeliveryList" />
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import PreSaleDeliveryList from '../../preSale-management/preSale-delivery/preSale-delivery-list';
import CurSaleDeliveryList from '../../curSale-management/curSale-delivery/curSale-delivery-list';

export default {
    name: 'inner-delivery-list',
    components: {
        PreSaleDeliveryList,
        CurSaleDeliveryList
    },
    data() {
        return {
            saleType: 'curSale'
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
